'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});
var _extends = require('@babel/runtime/helpers/extends');
var react = require('@chakra-ui/react');
var React = require('react');
function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}
function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}
var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Svg = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement("svg", _extends__default["default"]({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React__namespace.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React__namespace.createElement("path", {
    d: "M7.829 13.48c0-.095.025-.166.075-.214.05-.048.124-.072.22-.072.092 0 .164.025.215.074.05.05.076.12.076.211a.28.28 0 0 1-.077.208.29.29 0 0 1-.214.077c-.094 0-.167-.025-.218-.075a.28.28 0 0 1-.077-.21Zm.054-.574v-.123c0-.108.022-.2.068-.28a.924.924 0 0 1 .25-.253c.119-.083.196-.152.233-.204a.293.293 0 0 0 .056-.176.193.193 0 0 0-.08-.166.39.39 0 0 0-.224-.056c-.168 0-.36.054-.573.164l-.182-.367c.248-.14.512-.209.79-.209.23 0 .414.055.55.165a.544.544 0 0 1 .203.442.585.585 0 0 1-.084.318c-.055.09-.161.19-.318.302a.94.94 0 0 0-.203.181.275.275 0 0 0-.043.162v.1h-.443Z",
    fill: "currentColor"
  }), /*#__PURE__*/React__namespace.createElement("path", {
    d: "M13.404 18.179v.5a.32.32 0 0 1-.321.321h-.5v-.643h.179v-.178h.642Zm-9.762 0v.178h.18V19h-.5A.32.32 0 0 1 3 18.679v-.5h.642Zm2.126.178V19h-.974v-.643h.974Zm1.947 0V19h-.974v-.643h.974Zm1.947 0V19h-.974v-.643h.974Zm1.947 0V19h-.974v-.643h.974Zm1.795-2.105v.964h-.643v-.964h.643Zm-9.761-.138v1.032H3v-1.032h.643Zm9.761-1.79v.964h-.643v-.964h.643Zm-9.761-.275v1.033H3v-1.033h.643Zm9.761-1.652v.964h-.643v-.964h.643Zm-9.761-.412v1.032H3v-1.032h.643Zm9.94-1.372v.642h-.179v.179h-.643v-.5a.32.32 0 0 1 .322-.321h.5Zm1.885-.001v.643h-.942v-.643h.942Zm1.884 0v.643h-.941v-.643h.941Zm1.884 0v.643h-.942v-.643h.942ZM21 10.434v.5a.32.32 0 0 1-.321.32h-.5v-.642h.179v-.178H21ZM3.643 9.919v1.033H3V9.919h.643ZM21 8.025v1.204h-.643V8.025H21Zm-17.357-.17v1.032H3V7.855h.643ZM3.822 6v.642h-.18v.18H3v-.5A.32.32 0 0 1 3.322 6h.5Zm16.857 0a.32.32 0 0 1 .321.321v.5h-.643v-.179h-.178V6h.5ZM5.745 6v.643h-.962V6h.962ZM7.67 6v.643h-.962V6h.962Zm1.924 0v.643h-.962V6h.962Zm1.925 0v.643h-.962V6h.962Zm1.923 0v.643h-.962V6h.962Zm1.925 0v.643h-.962V6h.962Zm1.925 0v.643h-.963V6h.963Zm1.924 0v.643h-.962V6h.962Z",
    fill: "#3F3E4B"
  })));
});
var FwSet0LivingspaceUnknown = react.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__namespace.createElement(react.Icon, _extends__default["default"]({
    as: Svg
  }, props, {
    ref: ref
  }));
});
exports.FwSet0LivingspaceUnknown = FwSet0LivingspaceUnknown;